<template>
  <div>
    <Form :entityOrder="entityOrder" :title="`Consult ${entityOrder.uuid}`"/>

    <template v-if="loaded">
      <div class="ibox">
        <div class="ibox-title">
          Events
          <span class="float-right mr-3" style="cursor: pointer" @click="toggleRelation('events')">
            <EyeIcon v-if="mapRelation.events.show"/>
            <EyeOffIcon v-else/>
          </span>
        </div>

        <div class="ibox-content" v-show="mapRelation.events.show">
          <Events :entityOrder="entityOrder" :currentPath="currentPath" v-if="mapRelation.events.loaded"/>
        </div>
      </div>

      <div class="ibox" v-if="entityOrder.kind === 'consult'">
        <div class="ibox-title">
          Stages
          <span class="float-right mr-3" style="cursor: pointer" @click="toggleRelation('stages')">
            <EyeIcon v-if="mapRelation.stages.show"/>
            <EyeOffIcon v-else/>
          </span>
        </div>

        <div class="ibox-content" v-show="mapRelation.stages.show">
          <Stages :entityOrder="entityOrder" :currentPath="currentPath" v-if="mapRelation.stages.loaded"/>
        </div>
      </div>

      <div class="ibox">
        <div class="ibox-title">
          Items
          <span class="float-right mr-3" style="cursor: pointer" @click="toggleRelation('items')">
            <EyeIcon v-if="mapRelation.items.show"/>
            <EyeOffIcon v-else/>
          </span>
        </div>

        <div class="ibox-content" v-show="mapRelation.items.show">
          <Items :entityOrder="entityOrder" :currentPath="currentPath" v-if="mapRelation.items.loaded"/>
        </div>
      </div>

      <div class="ibox" v-if="entityOrder.kind === 'consult'">
        <div class="ibox-title">
          Requests
          <span class="float-right mr-3" style="cursor: pointer" @click="toggleRelation('requests')">
            <EyeIcon v-if="mapRelation.requests.show"/>
            <EyeOffIcon v-else/>
          </span>
        </div>

        <div class="ibox-content" v-show="mapRelation.requests.show">
          <Requests :entityOrder="entityOrder" :currentPath="currentPath" v-if="mapRelation.requests.loaded"/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import EntityProxy from '@/models/EntityProxy'
import Form from './Form'
// import Panel from '@/components/admin/maestro/Panel'

import Events from '@/components/admin/order_flow/OrderEvents.vue'
import Items from '@/components/admin/order_flow/OrderItems.vue'
import Stages from '@/components/admin/order_flow/OrderStages.vue'
import Requests from './Requests.vue'

import {mapMutations} from 'vuex'
import {EyeIcon, EyeOffIcon} from 'vue-feather-icons'

export default {
  components: {Items, Events, Form, Stages, Requests, EyeIcon, EyeOffIcon},
  computed: {
    entityOrder() {
      return EntityProxy.build(this.getModel || {})
    }
  },
  created() {
    this.asyncTemplateShow(this.id, {
      after: () => {
        this.setNameBreadcrumb(this.entityOrder.id)
        this.loaded = true
      }
    })
  },
  data: () => ({
    currentPath: '/admin/maestro/orders',
    modelPathPrefix: 'admin',
    nameModel: 'Order',
    loaded: false,
    mapRelation: {
      events: {loaded: false, show: false},
      stages: {loaded: false, show: false},
      items: {loaded: false, show: false},
      requests: {loaded: false, show: false},
    }
  }),
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
    toggleRelation(name) {
      this.mapRelation[name]['show'] = !this.mapRelation[name]['show']
      if (this.mapRelation[name]['show'])
        this.mapRelation[name]['loaded'] = true
    },
    buildPath() {
      return this.currentPath
    }
  },
  mixins: [ModelMapper],
  name: 'Show',
  props: {
    id: {required: true},
  }
}
</script>

<style scoped>

</style>
